import { useEffect, useState } from "react";
import { Icons } from "@/components/ui";
import { resolveCurrentAppVisual } from "@/lib/work-toast-app-visuals";
import { BROWSERS, type BrowserId } from "@/desktop/browser-connection";
import { useBrowserIcon } from "@/desktop/browser-connection-visual";
import { ToastLogoTile } from "./toast-pill";
import denkerAppIcon from "../../../src-tauri/icons/icon.png";

function ConnectionAppLogo({
  name,
  iconUrl,
  testId,
}: {
  name: string;
  iconUrl: string | null;
  testId: string;
}) {
  return (
    <ToastLogoTile testId={testId} className="rounded-[7px] bg-white">
      {iconUrl ? (
        <img
          src={iconUrl}
          alt={name}
          className="h-[22px] w-[22px] object-contain"
        />
      ) : (
        <Icons.Plug className="h-4 w-4 text-secondary" />
      )}
    </ToastLogoTile>
  );
}

/** Both apps use the same native icon pipeline, tile and image dimensions. */
export function ConnectionToastLogos({
  appName,
  iconUrl,
}: {
  appName: string;
  iconUrl: string | null;
}) {
  const [denkerIcon, setDenkerIcon] = useState(denkerAppIcon);
  useEffect(() => {
    let current = true;
    void resolveCurrentAppVisual().then((visual) => {
      if (current && visual?.iconUrl) setDenkerIcon(visual.iconUrl);
    });
    return () => {
      current = false;
    };
  }, []);
  return (
    <span
      className="flex shrink-0 items-center gap-1"
      data-testid="system-toast-logo-connection"
    >
      <ConnectionAppLogo
        name={appName}
        iconUrl={iconUrl}
        testId="system-toast-logo-app"
      />
      <ConnectionAppLogo
        name="Denker"
        iconUrl={denkerIcon}
        testId="system-toast-logo-denker-tile"
      />
    </span>
  );
}

/** A browser beside Denker: its own app icon, read where the toast shows. */
export function BrowserToastLogos({ browserId }: { browserId: BrowserId }) {
  return (
    <ConnectionToastLogos
      appName={BROWSERS[browserId].name}
      iconUrl={useBrowserIcon(browserId)}
    />
  );
}
